<template>
    <!--    <van-popup v-model="show" overlay-class="container">-->
    <div class="container">
        <div v-if="!loading" style="width: 90%;margin: 0px auto;margin-top:10px;width: 90%;text-align: left;">
            <van-field
                    v-model="formModel.name"
                    clearable
                    label="名称"
                    label-align="left"
                    placeholder="请输入名称"
                    required
            ></van-field>
            <van-field
                    v-model="formModel.taxNumber"
                    clearable
                    label="税号"
                    placeholder="请输入税号"
                    label-align="left"

                    required
            ></van-field>
            <van-field
                    v-model="formModel.address"
                    clearable
                    placeholder="请输入单位地址" label-align="left"
                    label="单位地址"
            ></van-field>
            <van-field
                    v-model="formModel.tele"
                    clearable label-align="left"

                    placeholder="请输入电话号码"
                    label="电话号码"
            ></van-field>
            <van-field
                    v-model="formModel.depositBank" label-align="left"

                    clearable
                    placeholder="请输入开户银行"
                    label="开户银行"
            ></van-field>
            <van-field
                    v-model="formModel.bank"
                    clearable
                    placeholder="请输入银行账户" label-align="left"
                    label="银行账户"
            ></van-field>
            <div class="flex-form-queue" style="margin-top: 30px;">
                <mobile-button color="#005423" class="btn-font" @click="add" style="width: 40%;text-align: center">新 增
                </mobile-button>
                <mobile-button color="#005423" class="btn-font" @click="cancel" style="width: 40%;text-align: center">重
                    置
                </mobile-button>
            </div>
        </div>
        <pre-page v-if="!loading" title="返 回" @back="back"></pre-page>
        <van-loading color="#005423" v-else style="min-height: 200px; line-height: 200px;"/>

    </div>
    <!--    </van-popup>-->
</template>
<script>
    import MobileButton from "components/mobile-button/index";
    import apiPayConfirm from "api/pay-confirm";
    import prePage from "components/pre-page/index";

    export default {
        // props: {
        //     show: {
        //         type: Boolean,
        //         default: false,
        //     },
        // },
        name: "ticketAddDialog",
        components: {MobileButton, prePage},
        data() {
            return {
                show: false,
                search: '1234',
                loading: false,
                formModel: {
                    ticketIds: "",
                    name: "",
                    taxNumber: "",
                    address: "",
                    tele: "",
                    depositBank: "",
                    bank: "",
                    titleType: 2,
                },
            }
        },
        methods: {
            handle(startTime) {
                this.$nextTick(() => {
                    let t = 800 - (new Date() - startTime)
                    if (t > 0) {
                        setTimeout(() => {
                            this.loading = false
                        }, t);
                    } else {
                        this.loading = false
                    }
                })
            },
            onShow() {
                this.show = true
            },
            onClose() {
                this.show = false
            },
            back() {
                // this.$router.back()
                this.$emit('back')
            },
            cancel() {
                this.reset()
            },
            add() {
                let startTime = new Date()
                this.loading = true
                let param = this.formModel
                apiPayConfirm.ticketUpdate(param).then(res => {
                    this.$emit('select', param)
                    this.reset()
                }).catch(err=>{
                    this.loading=false
                })
                this.handle(startTime)
            },
            reset() {
                this.formModel = {
                    ticketIds: "",
                    name: "",
                    taxNumber: "",
                    address: "",
                    tele: "",
                    depositBank: "",
                    bank: "",
                    titleType: 2,
                }
            }
        },
        created() {
        },
    }
</script>
<style lang="scss" scoped>
    .container {
        width: 100%;
        height: 100%;
    }

</style>
